export const asResult = (error, data, message = "Zapisano poprawnie") => error ? { status: "error", message: error.message } : { status: "success", message, data };

// Naruszenie indeksu numeru dokumentu daje surowy komunikat Postgresa, z którego
// użytkownik nie dowie się, co poprawić.
export const asDocumentSave = (error, savedMessage, duplicateMessage) => {
  if (!error) return { status: "success", message: savedMessage, data: null };
  if (/_owner_number_key/.test(error.message)) return { status: "error", message: duplicateMessage };
  return { status: "error", message: error.message };
};

// PostgREST zwraca domyślnie najwyżej 1000 wierszy (ustawienie max-rows), więc
// każdą listę trzeba dociągnąć kolejnymi stronami. Bez tego tabela klientów
// kończyła się w połowie alfabetu, mimo że rekordy są w bazie.
export const fetchAllRows = async (buildQuery, pageSize = 1000) => {
  const rows = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await buildQuery().range(from, from + pageSize - 1);
    if (error) return { error };
    rows.push(...data);
    if (data.length < pageSize) return { data: rows };
  }
};

export const customerFromDb = (row) => row && ({ ...row, _id: row.id, phonenr: row.phone_number, selldate: row.sell_date, hasInvoice: row.has_invoice });
export const productFromDb = (row) => row && ({ ...row, _id: row.id });
export const customerToDb = (c) => ({ name:c.name,nip:c.nip||null,city:c.city||null,street:c.street||null,phone_number:c.phonenr||null,sell_date:c.selldate||null,info:c.info||null,has_invoice:Boolean(c.hasInvoice) });
export const productToDb = (p) => ({ name:p.name,brand:p.brand||null,model:p.model||null,quantity:p.quantity,price_net:p.price_net,price_gross:p.price_gross,vat:p.vat });
